import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register',
  template: `
    <p>
      register works!
    </p>
  `,
  styles: []
})
export class RegisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
